const chatMenu: any = {
  id: "chat",
  title: "Chat",
  translate: "MENU.CHAT",
  type: "item",
  icon: "message-square",
  url: "dashboard/chat",
  order: 2,
};
export default chatMenu;
